<div class="w-full z-50" [class.sent]="isSent">
    @if (!isSent) {
        <p-message
            severity="info"
            variant="text"
            class="text-center"
            styleClass="w-full text-center !rounded-none">
            <ng-template class="w-full mx-auto" #container>
                <div class="w-full mx-auto">
                    To get a partner or upgrade your plan, you must verify your email
                    address.<fa-icon
                        [icon]="faInfoCircle"
                        (click)="openVerification.emit()"
                        style="cursor: pointer"></fa-icon>
                    <a
                        pButton
                        severity="info"
                        size="small"
                        [text]="true"
                        [class.pointer-events-none]="isResendDisabled"
                        [class.opacity-60]="isResendDisabled"
                        [attr.aria-disabled]="isResendDisabled"
                        [attr.tabindex]="isResendDisabled ? -1 : null"
                        (click)="onResendVerification($event)"
                        >Resend verification email.</a
                    >
                </div>
            </ng-template>
        </p-message>
    } @else {
        <p-message
            severity="success"
            variant="text"
            class="text-center"
            styleClass="w-full text-center !rounded-none">
            <ng-template class="w-full mx-auto" #container>
                <div class="w-full mx-auto">
                    We sent a verification email to {{ email }}. Please follow the instructions in
                    it.

                    <fa-icon
                        [icon]="faInfoCircle"
                        (click)="openVerification.emit()"
                        style="cursor: pointer"></fa-icon>
                </div>
            </ng-template>
        </p-message>
    }
</div>
